import { useContext, useState, useEffect, useRef } from "react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { StatusBar } from "expo-status-bar";
import {
  StyleSheet,
  TextInput,
  View,
} from "react-native";
import SafeAreaView from "../components/SafeAreaView";
//import Feather from "react-native-vector-icons/Feather";
import { Feather } from "../components/VectorIcons";
import { AuthContext } from "../context/AuthContext";
import axios from "axios";
import qs from "qs";

import FirmList from "../components/FirmList";

//import { firmData } from "../model/data";
import { BASE_URL } from "../config";
import CustomButton from "../components/CustomButton";
import { pageTitle, getSchemeStyle } from "../context/helper";
import { EventRegister } from "react-native-event-listeners";
import * as Config from "../config";
import ActivityScreen from "./activityscreen";

const FirmSelect = ({ navigation, route }) => {
  const schemeStyles = getSchemeStyle();

  const { changeFirm, logout, userToken, userInfo, useFirm, isService } =
    useContext(AuthContext);

  const [dataLoaded, setDataLoaded] = useState(false);
  const [filterData, setFilterData] = useState([]);
  const [searchText, setSearchText] = useState();

  const firmData = useRef([]);
  const firmID = useRef(route.params?.firmid);

  const loadData = async () => {
    setDataLoaded(false);

    const url = `${BASE_URL}/getdata`;
    let data = {
      action: "firmlist",
    };
    let options = {
      method: "POST",
      headers: {
        "content-type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + userToken,
      },
      data: qs.stringify(data),
      url,
    };
    await axios(options)
      .then((res) => {
        let _firmdata = res.data;
        //console.log(_firmdata);
        if (_firmdata && _firmdata.result == "OK") {
          firmData.current = _firmdata.data;
          setFilterData(
            _firmdata.data.filter((item) => (item.firmID!=0) && (item.lockedUsers || item.errors))
          );
        }
      })
      .catch((e) => {
        console.log(`FirmList error ${e}`);
      });
    setDataLoaded(true);
  };

  const pressFirmHandler = (id) => {
    let firm = firmData.current.find((data) => data.firmID === id);
    if (route.params) {
      EventRegister.emit(Config.Events.FIRM_SELECT, {
        firmid: firm.firmID,
        firmname: firm.firmName,
      });
      navigation.goBack();
    } else {
      if (firm) changeFirm(firm.firmID, firm.firmName);
    }
  };

  const changeSearchText = (text) => {
    setSearchText(text);
    if (text.length == 0)
      setFilterData(
        firmData.current.filter((item) => (item.firmID!=0) && (item.lockedUsers || item.errors))
      );
    else
      setFilterData(
        firmData.current.filter((item) => (item.firmID!=0) && item.firmName.toLowerCase().includes(text.toLowerCase()))
      );
  };
  useEffect(() => {
    loadData();
  }, []);

  if (!dataLoaded) {
    return (
      <ActivityScreen />
    );
  }

  return (
    <SafeAreaView style={[styles.mainContainer,schemeStyles.Background]}>
      <View style={[styles.inputContainer,schemeStyles.Border]}>
        <Feather
          name="search"
          size={20}
          color={schemeStyles.lightGrayIcon.color}
          style={styles.searchIcon}
        />
        <TextInput
          placeholder="Search"
          placeholderTextColor={schemeStyles.placeholderText.placeholderColor}
          style={[styles.inputField,schemeStyles.defaultText]}
          onChangeText={(text) => {
            changeSearchText(text);
          }}
        />
      </View>
      {firmData.current.length > 0 ? (
        <FirmList
          data={filterData}
          onPressFirm={pressFirmHandler}
          noaddr={route.params !== undefined}
        />
      ) : (
        <CustomButton
          style={[styles.sendButton,schemeStyles.buttonText]}
          onPress={() => {
            logout();
          }}
        >
          Logout
        </CustomButton>
      )}
    </SafeAreaView>
  );
};

const Stack = createNativeStackNavigator();
const FirmSelectStack = () => {
  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      <Stack.Screen
        component={FirmSelect}
        name="FirmSelect"
        options={{ title: pageTitle("Firma wählen") }}
      />
    </Stack.Navigator>
  );
};

export default FirmSelectStack;

const styles = StyleSheet.create({
  mainContainer: {
    flex: 1,
    paddingTop: 10,
  },
  searchIcon: {
    marginRight: 5,
  },
  inputContainer: {
    flexDirection: "row",
    alignItems: "center",
    borderWidth: 1,
    borderRadius: 8,
    paddingHorizontal: 10,
    marginHorizontal: 10,
  },
  inputField: {
    flex: 1,
    paddingVertical: 8,
  },
  sendButton: {
    margin: 10,
  },
});
